import { render, staticRenderFns } from "./NFTImport.vue?vue&type=template&id=ab588446&scoped=true&"
import script from "./NFTImport.vue?vue&type=script&lang=js&"
export * from "./NFTImport.vue?vue&type=script&lang=js&"
import style0 from "./NFTImport.vue?vue&type=style&index=0&id=ab588446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab588446",
  null
  
)

export default component.exports